"use client";

import { Text } from "../../ui/text";
import InstitutionalProductCard from "./institutional-product-card/institutional-product-card";
import {
  useInstitutionalCards,
  type UseInstitutionalCardsProps,
} from "./use-institutional-cards";
import { motion as m } from "motion/react";

export type InstitutionalCardsProps = UseInstitutionalCardsProps;

function InstitutionalCards(props: InstitutionalCardsProps) {
  const { sectionName, className, styles, data } = useInstitutionalCards(props);
  const { theme, title, cards } = data;

  return (
    <m.section
      className={styles.base({ className })}
      data-section-name={sectionName}
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ amount: 0.1, once: true }}
    >
      <div className={styles.wrapper()}>
        <div className={styles.heading()}>
          <Text
            className={styles.title()}
            size="tiny"
            tag="h2"
            theme={theme}
            weight="medium"
          >
            {title}
          </Text>
        </div>

        {!!cards && (
          <div className={styles.cards()}>
            {cards.map((card, index) => (
              <m.div
                key={card.id}
                className={"basis-1/4"}
                variants={{
                  offscreen: {
                    y: 100,
                    opacity: 0,
                  },
                  onscreen: {
                    y: 0,
                    opacity: 1,
                    transition: {
                      duration: 0.7,
                      delay: 0.1 * index,
                      ease: "circOut",
                    },
                  },
                }}
              >
                <InstitutionalProductCard data={card} index={index} />
              </m.div>
            ))}
          </div>
        )}
      </div>
    </m.section>
  );
}

export default InstitutionalCards;
